import React from 'react';
import { Statistic } from 'antd';
import { formatWithPostfixOrEmpty } from 'shared/utils/format-with-postfix-or-empty';
import { CURRENCY_SIGN, ECurrency } from 'types/currencies';
import type { IStatisticMoney } from 'components/common/statistic-money/types';
import styles from './statistic-money.module.scss';

export const StatisticMoney: React.FC<IStatisticMoney> = ({ title, currency, valueInDefault, value, valueStyle }) => {
  const isDefaultCurrency = currency === ECurrency.EUR;

  const valueFormatted = isDefaultCurrency
    ? formatWithPostfixOrEmpty(value, CURRENCY_SIGN[ECurrency.EUR])
    : `${valueInDefault ? '≈' : ''} ${formatWithPostfixOrEmpty(valueInDefault, CURRENCY_SIGN[ECurrency.EUR])}`;

  return (
    <div>
      <Statistic title={title} value={valueFormatted} valueStyle={valueStyle} />
      {!isDefaultCurrency && value && (
        <div className={styles.mainValueBox}>{formatWithPostfixOrEmpty(value, CURRENCY_SIGN[currency])}</div>
      )}
    </div>
  );
};
